import axios from 'axios';
import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { getIntendType, getBundleCategory, isJointTransactionFlow, getJointTransactionLine, enablePlanInfoAPICall, isFCCInternalPage } from '../../components/common/Helpers/index';
import { getFormatedDate } from '../../components/Web/AddressSearch/constant';

export const getDataFromApi = (data) => ({
  type: Constants.GET_DATA_FROM_API,
  data,
});

export const CBandPlansAPI = (data) => ({
  type: 'PLANS_API',
  data,
});

export const updateCurrentSfo = (data) => ({
  type: 'UPDATE_SFO',
  data,
});

export const getPlansCBand = () => {
  const intendType = `${getIntendType()}`;
  const postData = {
    intentType: intendType,
    availableSpoCategoryFilters: getBundleCategory(),
    ...(isJointTransactionFlow() ? { isJointCombo: 'Y', mtn: `${getJointTransactionLine()}` } : {}),
  };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().cBandPlans}`;
  return HttpService.post(apiURL, postData);
};

export const bannerPlansAPI = (data) => ({
  type: Constants.BANNER_PROMOTION_FLOW,
  data,
});

export const getBannerAPI = (data) => {
  const postData = {
    customerResponse: {
      responseList: [
        {
          mtn: 'newLine1',
          customerType: 'N',
          zipCode: data?.zipCode,
          billingState: data?.state,
        },
      ],
    },
    contextInfo: {
      callReason: 'PlanPromotions',
      category: 'Promotions',
      pageContext: 'FWAPlansOverview',
    },
  };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().localOfferBanner}`;
  return HttpService.post(apiURL, postData);
};

export const planInformationDetails = (data) => ({
  type: 'PLAN_INFORMATION',
  data,
});

export const getPlanInformationDetails = () => {
  if(enablePlanInfoAPICall()){
    const apiUrl = window.location.hostname === 'localhost' ? `${getSecureBaseUrl()}${apiUrls().planInformationDetails}` : apiUrls().planInformationDetails;
    return axios.get(apiUrl);
  }
};

export const cBandPlanDetails = (data) => ({
  type: 'CBAND_FED',
  data,
});

export const getPlansCBandDetails = () => {
  // '/content/caas/c-band.model.json'
  // const apiUrl = apiUrls().cBandPlansDetails;
  // const apiUrl = `${getSecureBaseUrl()}` + apiUrls().cBandPlansDetails;

  const apiUrl = window.location.hostname === 'localhost' ? `${getSecureBaseUrl()}${apiUrls().willowFEDURL}` : apiUrls().willowFEDURL;
  return axios.get(apiUrl);
};

export const selectedPlan = (data) => ({
  type: 'C_BAND_SELECETD_PLAN',
  data,
});

export const clearInactiveBundles = (data) => ({
  type: Constants.UPDATE_SFO_DATA,
  response: data,
});

export const dawCoupon = (data) => ({
  type: 'DAW_COUPON',
  value: data,
});
export const selectedPlanAPI = (data) => {
  const intendType = `${getIntendType()}`;
  const isJoint = isJointTransactionFlow();
  const line = isJoint ? `${getJointTransactionLine()}` : 'newLine1';

  const postData = {
    cartInfo: {
      cartCreator: '',
      processingMTN: line,
      processStep: 'PlanSelection',
      intendType,
    },
    data: {
      lines: [
        {
          ...(isJoint ? { isJointCombo: 'Y' } : {}),
          mtn: line,
          plan: {
            id: data.planId,
            isRecommendedPlan: false,
            recommender: '',
            SFO: [], // data.sfo,
          },
        },
      ],
      parentMtn: '',
    },
  };
  if (data.isWHWPlus) {
    postData.data.lines.push({
      accessories: {
        remove: [
          {
            qty: '2',
            id: 'CE1000A',
            category: 'Home Services',
          },
        ],
      },
      depletionType: data.depletionType,
      ispuFlow: 'false',
      mtn: line,
      eupNoPromoFlow: 'false',
      inWithVerizonOpted: false,
      lineWithSkipMDN: false,
      editSim: false,
      protectionNotRequired: 'false',
    });
  }
  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCBandPlan}`;
  return HttpService.post(apiURL, postData);
};

export const resetPromoUpdated = () => ({ type: Constants.RESET_PROMO_UPDATED });

export const toggleACPDetailModal = () => ({ type: Constants.TOGGLE_ACP_MODAL });
export const toggleVFDetailModal = () => ({ type: Constants.TOGGLE_VF_MODAL });
export const restACPDetailModal = () => ({ type: Constants.RESET_ACP_MODAL });
export const restVFDetailModal = () => ({ type: Constants.RESET_VF_MODAL });
export const fccLabelContentActions = (data) => ({
  type: Constants.FCC_LABEL,
  data,
});

export const getFCCLabelDetailsFromAPI = (data) => {
  let queryString = 'vzw/fcc/wireless/getPlanDetails.all.json'
  if(isFCCInternalPage()){
    const selectedFCCDate = new Date(data);
    const {date,month,year} = getFormatedDate(selectedFCCDate)
    queryString = `vzw/fcc/wireless/getPlanDetails.all.${year}-${month}-${date}.json`
  }
  const apiUrl = `${getSecureBaseUrl()}${apiUrls().broadBandFactURL}`;
  console.log(apiUrl, 'url');
  return HttpService.post(apiUrl, {
    queryString,
  });
};

export const updateACPModalALStatus = (value) => ({ type: Constants.UPDATE_ACPMODAL_AL_STATUS, value });
export const updateVFModalALStatus = (value) => ({ type: Constants.UPDATE_VFMODAL_AL_STATUS, value });
